import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function TeamList() {
    const [teams, setTeams] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log('Attempting to fetch from:', `${process.env.REACT_APP_API_URL}/stats/teams/`);

        fetch(`${process.env.REACT_APP_API_URL}/stats/teams/`)
            .then((response) => {
                console.log('Response received:', response);

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                console.log('Data received:', data);
                setTeams(data);
            })
            .catch((err) => {
                console.error('Error during fetch:', err);
                setError(err.message);
            });
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <h1>Teams</h1>
            <ul>
                {teams.map((team) => (
                    <li key={team.id}>
                        <Link to={`/team/${team.id}`}>{team.name}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default TeamList;
